import cookie from "js-cookie";
import gql from "graphql-tag";
import { useMutation } from "@apollo/client";

const LOGIN_MUTATION = gql`
  mutation LoginMutation($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      user {
        id
        email
        isAdmin
        isAd
        deliveryNotesVisitor
        selectedCompany {
          id
          isBlocked
          name
          ingresId
          carloPartnerId
          logo
        }
        companies {
          id
          company {
            id
            name
            isBlocked
            ingresId
            carloPartnerId
            logo
          }
        }
        presetPassword
      }
      access_token
    }
  }
`;

export function useAuth() {
  const [login] = useMutation(LOGIN_MUTATION);

  const handleLogin = async (email: string, password: string) => {
    const { data } = await login({
      variables: { email, password },
    });

    if (data?.login.access_token) {
      cookie.set("access_token", data.login.access_token, {
        httpOnly: false,
      });

      localStorage.setItem("user", JSON.stringify(data?.login.user));

      const backup = localStorage.getItem('filters');
      if (backup) {
        const parsed = JSON.parse(backup);
        Object.entries(parsed).forEach((value: any) => {
          localStorage.setItem(value[1][0], value[1][1]);
        });
      }

      return data?.login?.user;
    }

    return false;
  };

  return {
    handleLogin,
  };
}
